export default "__VITE_ASSET__hd3xcerq__"